import { byMethod } from '@oysterjs/core/graphql/actions';
import type { RouteObject } from 'react-router-dom';
import { submitDisconnectMailbox } from '~/api/data/mailbox/mutations';
import { loadMailboxSettings, MailboxSettingsEntry } from '~/pages/settings/mailbox-offboarding';

export const mailboxSettingsRoute: RouteObject = {
  children: [
    {
      path: 'mailbox',
      loader: loadMailboxSettings,
      element: <MailboxSettingsEntry />,
      children: [
        {
          path: 'disconnect',
          action: byMethod({
            POST: submitDisconnectMailbox
          })
        }
      ]
    }
  ]
};
